"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
var lodash_noop_1 = __importDefault(require("lodash.noop"));
var react_1 = __importStar(require("react"));
var Box_1 = require("./Box");
var useKeyboardSelection_1 = require("./common/useKeyboardSelection");
var core_1 = require("./core");
var Popup_1 = require("./Popup");
var VStack_1 = require("./VStack");
var SelectedContext = react_1.createContext(false);
function Dropdown(_a) {
    var children = _a.children, items = _a.items, _b = _a.onHide, onHide = _b === void 0 ? lodash_noop_1.default : _b, placement = _a.placement, _c = _a.preventBlurOnSelection, preventBlurOnSelection = _c === void 0 ? false : _c, _d = _a.selectOnTab, selectOnTab = _d === void 0 ? false : _d, show = _a.show, variant = _a.variant;
    var preRef = react_1.useRef(null);
    var onClick = react_1.useCallback(function (index) {
        var _a, _b;
        if (!preRef.current)
            return;
        var stackChildren = Array.from((_b = (_a = preRef.current.parentElement) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : []);
        var preRefIndex = stackChildren.indexOf(preRef.current);
        stackChildren[preRefIndex + 1 + index].click();
    }, []);
    var selectedIndex = useKeyboardSelection_1.useKeyboardSelection({ length: items.length, onClick: onClick, onHide: onHide, selectOnTab: selectOnTab, show: show });
    return (react_1.default.createElement(Popup_1.Popup, { content: react_1.default.createElement(Box_1.Box, { background: '$white', border: '$grey5', borderRadius: '$4px', maxHeight: maxDropdownHeight, minWidth: variant === 'small' ? undefined : Popup_1.minPopupWidth, onClick: stopPropagation, onMouseDown: preventBlurOnSelection ? preventDefault : undefined, shadow: '$popup', spaceVert: variant === 'small' ? '$4px' : '$8px' },
            react_1.default.createElement(VStack_1.VStack, { onClick: onHide },
                react_1.default.createElement("div", { ref: preRef, hidden: true }),
                items.map(function (item, index) {
                    var _a;
                    return (react_1.default.createElement(SelectedContext.Provider, { key: (_a = item.key) !== null && _a !== void 0 ? _a : index, value: index === selectedIndex }, item));
                }))), onHide: onHide, placement: placement, show: show }, children));
}
exports.Dropdown = Dropdown;
var maxDropdownHeight = core_1.getCustomSize(150);
function stopPropagation(event) {
    event.stopPropagation();
}
function preventDefault(event) {
    event.preventDefault();
}
Dropdown.Item = function DropdownItem(_a) {
    var children = _a.children, onClick = _a.onClick;
    var selected = react_1.useContext(SelectedContext);
    var scrollRef = useScrollIntoView(selected);
    return (react_1.default.createElement(Box_1.Box, { ref: scrollRef, clickable: true, onClick: onClick && (function () { return onClick(); }) }, children({ selected: selected })));
};
/** Default item version with basic hover and selected states */
Dropdown.DefaultItem = function DropdownDefaultItem(_a) {
    var children = _a.children, onClick = _a.onClick;
    return (react_1.default.createElement(Dropdown.Item, { onClick: onClick }, function (_a) {
        var selected = _a.selected;
        return (react_1.default.createElement(ItemWrapper, { selected: selected },
            react_1.default.createElement(Box_1.Box, { clickable: true, spaceHorz: '$16px', spaceVert: '$8px' }, children)));
    }));
};
var ItemWrapper = core_1.styled('div', { ':hover': { backgroundColor: '$grey2' } }, { selected: { true: { backgroundColor: '$grey2' } } });
function useScrollIntoView(active) {
    if (active === void 0) { active = false; }
    var ref = react_1.useRef(null);
    react_1.useEffect(function () {
        var _a;
        if (active) {
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
    }, [active]);
    return ref;
}
